
export class DealPhoto {
    dealPhotoId: number;
    caption: string;
    photopath: string;
    photoname: string;
    dealId: number;
    dealOwner: string;
}